<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "frontend"
    }
</script>

<style scoped>

</style>